import { Box, Container, Paper, styled, Typography } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";

export const StyledInputBox = styled(Box, { label: "StyledInput_Box" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        //backgroundColor: 'red',

        '.MuiInputBase-root.MuiInput-root.MuiInput-underline': {
            fontSize: 14,

            'svg': {
                transform: 'rotate(90deg)',
                fontSize: 15,
                color: StyleguideSavioColors.mainBlue,
            },
            '&:before': {
                borderColor: StyleguideSavioColors.mainBlue + " !important",
            },

            '&.Mui-error': {
                '&:before': {
                    borderColor: "#d32f2f !important",
                },
            }
        }
    }))

export const StyledInputBoxRadio = styled(Box, { label: "StyledInput_BoxRadio" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        'label': {
            fontSize: 14,
            fontWeight: 700,
            color: StyleguideSavioColors.mainBlue,
            marginBottom: 2,
        },
        '.MuiRadio-root': {
            padding: 2,
        },
        '.MuiFormGroup-root': {
            'label': {
                marginLeft: -5,
                marginBottom: 0,
                'span': {
                    fontSize: 14,
                    paddingTop: 1,
                }
            }
        },


        
        

    }))

export const DialogContainer = styled(Box, { label: "WarrantyMissing-Container" })
    (({ theme }) => ({
        minWidth: 650,
        gap: "10px",
        display: "flex",
        flexDirection: "column",
        maxHeight: 400,
        paddingTop: 7,

        '> div': {
            '&:first-of-type': {
                //dentro head tabella
                borderBottom: '1px solid ' + StyleguideSavioColors.mainBlue,
                //color: 'red',
                '> div': {
                    'p': {
                        fontSize: 14,
                        textTransform: 'uppercase',
                        color: StyleguideSavioColors.mainBlue,
                        fontWeight: StyleguideSavioFonts.bold,
                        width: '100%',
                        display: 'block',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        paddingTop: 9,
                        paddingBottom: 9,
                    }
                },










            }
        }
    }))

export const DialogReasonContainer = styled(Box, { label: "WarrantyMissingReason-Container" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        gap: 5,
        alignItems: "center",
        paddingTop: 7
    }))

export const PaperContainer = styled(Paper, { label: "WarrantyMissing-PaperContainer" })
    (({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        padding: "5px 0px",
        marginBottom: 5,

        '> div': {


            'label':{
                color: StyleguideSavioColors.text.black,
                fontWeight: StyleguideSavioFonts.normal,
            },
            '> div': {
                '&:first-of-type': {

                    paddingBottom: 5,

                    'p': { fontSize: 14, },
                    'button': {
                        color: StyleguideSavioColors.mainBlue
                    },

                    'svg.noNote': {
                        color: StyleguideSavioColors.text.black,
                       // opacity: 0.4,
                    },

                    'div': { fontSize: 14, }

                }
            }
        }
    }))

    export const Label2 = styled(Typography, { label: "WarrantyMissing-Label2" })
    (({ theme }) => ({
       
       fontSize: 14,
       textTransform: 'uppercase',
       marginTop: 7,

    }))

    export const Value = styled(Box, { label: "WarrantyMissing-Value" })
    (({ theme }) => ({
      
       fontSize: 14,
      

    }))